import {BarcodeScanner} from "./barcode_scanner.js";

const scanSupported = !!(navigator.mediaDevices && navigator.mediaDevices.getUserMedia);

if (scanSupported) {
    document.getElementById('scan-navbar-search-btn')?.classList.remove('hidden');
}

document.getElementById('scan-navbar-search-btn')?.addEventListener('click', () => {
    const scanner = new BarcodeScanner((code) => {
        const input = document.getElementById('search-modal-input');
        input.value = code;
        document.getElementById('navbar-search-form').dispatchEvent(
            new Event('submit', {bubbles: true, cancelable: true})
        );
    });
    scanner.start();
});
